import { Card, Divider, Stack } from "@mui/material";
import InputControl from "../../../shared/components/InputControl";
import { Loader, LoadingButton } from "../../../shared";
import { useContactConfig } from "../hooks";
import { TenantInfoText } from "../components";

export const ContactConfig = () => {
  const { formValidator, state, onChange, onSubmit } = useContactConfig();
  const { formData } = state;

  const validations = {
    support_phone: formValidator.current.message(
      "Support Phone",
      formData.support_phone,
      "min:7|max:15",
    ),
    support_email: formValidator.current.message(
      "Support Email",
      formData.support_email,
      "email",
    ),
    replay_email: formValidator.current.message(
      "Reply Email",
      formData.replay_email,
      "email",
    ),
  };

  return (
    <Card
      sx={{ p: "24px", gap: "20px", display: "flex", flexDirection: "column" }}
    >
      <TenantInfoText infoKey="contactInfo" alert />

      {state.isLoading ? (
        <Stack height="129px" justifyContent="center" alignItems="center">
          <Loader />
        </Stack>
      ) : (
        <>
          <Stack
            display="flex"
            flexDirection={{ xs: "column", sm: "row" }}
            gap="20px"
          >
            <InputControl
              name="support_phone"
              label="Display Phone Number"
              type="tel"
              placeholder="0800000000"
              value={formData.support_phone}
              onChange={onChange}
              error={!!validations.support_phone}
              helperText={validations.support_phone}
            />
            <InputControl
              name="support_email"
              label="Display Email"
              type="email"
              placeholder="support@example.com"
              value={formData.support_email}
              onChange={onChange}
              error={!!validations.support_email}
              helperText={validations.support_email}
            />
          </Stack>
          {/* <InputControl
            name="replay_email"
            label="Reply Email"
            type="email"
            placeholder="support@example.com"
            value={formData.replay_email}
            onChange={onChange}
            error={!!validations.replay_email}
            helperText={validations.replay_email}
          /> */}

          <Divider />
          <LoadingButton
            variant="contained"
            sx={{ ml: "auto", width: { xs: "100%", sm: "max-content" } }}
            onClick={onSubmit}
            loading={state.isSubmitting}
            disabled={!state.hasChanges}
          >
            Save
          </LoadingButton>
        </>
      )}
    </Card>
  );
};
